import { combineEpics } from 'redux-observable';
import { listStoreProducts, renderProduct } from './product.js';
export const rootEpic = combineEpics(listStoreProducts, renderProduct);
